import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserProps } from "@/interface/account";

const initialState: UserProps = {
	name: "",
	fullName: "",
	email: "",
	phoneNumber: "",
	avatarKey: "",
	token: "",
	id: "",
	isVerified: false,
	dateOfBirth: "",
	addresses: [],
	groupCarts: [],
	lastRoute: "",
	lastNonAuthRoute: "",
};

const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		updateUser: (state, action: PayloadAction<Partial<UserProps>>) => {
			return {
				...state,
				name: action.payload.name,
				id: action.payload.id,
				avatarKey: action.payload.avatarKey,
				email: action.payload.email,
				phoneNumber: action.payload.phoneNumber,
				token: action.payload.token,
				isVerified: action.payload.isVerified,
				dateOfBirth: action.payload.dateOfBirth,
				addresses: action.payload.addresses,
			};
		},
		clearUserInfo: state => {
			state.name = "";
			state.email = "";
			state.phoneNumber = "";
			state.avatarKey = "";
			state.id = "";
			state.token = "";
			state.isVerified = false;
			state.dateOfBirth = "";
			state.addresses = [];
		},
		updateLastRoute: (state, action: PayloadAction<string>) => {
			state.lastRoute = action.payload;
		},
		updateLastNonAuthRoute: (state, action: PayloadAction<string>) => {
			state.lastNonAuthRoute = action.payload;
		},
		updateGroupCart: (state, action: PayloadAction<Partial<UserProps>>) => {
			return {
				...state,
				groupCarts: action.payload.groupCarts,
			};
		},
		updateSignupUser: (state, action: PayloadAction<Partial<UserProps>>) => {
			return {
				...state,
				id: action.payload.id,
				email: action.payload.email,
			};
		},
		updateAddress: (state, action: PayloadAction<Partial<UserProps>>) => {
			return {
				...state,
				addresses: action.payload.addresses,
			};
		},
		updateRecoverPassword: (state, action: PayloadAction<Partial<UserProps>>) => {
			return {
				...state,
				id: action.payload.id,
			};
		},
		updateAvatar: (state, action: PayloadAction<string>) => {
			return {
				...state,
				avatarKey: action.payload,
			};
		},
		updateEditInfo: (state, action: PayloadAction<Partial<UserProps>>) => {
			return {
				...state,
				name: action.payload.fullName,
				dateOfBirth: action.payload.dateOfBirth,
				email: action.payload.email,
				phoneNumber: action.payload.phoneNumber,
			};
		},
	},
});

export default userSlice.reducer;
export const {
	updateUser,
	clearUserInfo,
	updateGroupCart,
	updateSignupUser,
	updateAddress,
	updateRecoverPassword,
	updateAvatar,
	updateEditInfo,
	updateLastRoute,
	updateLastNonAuthRoute,
} = userSlice.actions;
